var map = {
	"./MPtubiao.svg": "tzxy",
	"./back.svg": "RN8c",
	"./card-liulan.svg": "pxbM",
	"./card-shijian.svg": "csBU",
	"./collection-active.svg": "31Vd",
	"./collection.svg": "a4vn",
	"./comment.svg": "SdtW",
	"./delete.svg": "Imjp",
	"./edit.svg": "ql+d",
	"./eye-close.svg": "m3M2",
	"./eye.svg": "4wdf",
	"./gather-active.svg": "gI2l",
	"./gather.svg": "xaxM",
	"./gift.svg": "UndF",
	"./icon-back.svg": "jC1s",
	"./like-active.svg": "fDBV",
	"./like.svg": "JDw2",
	"./list.svg": "vuHp",
	"./mp3.svg": "oLO4",
	"./note-blank.svg": "8N/q",
	"./note.svg": "yZSt",
	"./people.svg": "GPe0",
	"./pink.svg": "hQMP",
	"./question.svg": "noTa",
	"./up.svg": "S+/b",
	"./wenjian.svg": "NeD2",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 57